"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldConfig = exports.FieldConfigDefinition = void 0;

var _types = require("../../types");

var _textfieldConfig = require("../Textfield/textfieldConfig");

var _dateConfig = require("../Date/dateConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var FieldRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldRuleDefinition;
});

var FieldConfigDefinition = _flowRuntime["default"].type("FieldConfigDefinition", _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string()), _flowRuntime["default"].property("validation", _flowRuntime["default"].array(_flowRuntime["default"].ref(FieldRuleDefinition)), true)));

exports.FieldConfigDefinition = FieldConfigDefinition;

var fieldConfigs = function fieldConfigs() {
  return [_textfieldConfig.emailConfig, _dateConfig.dateConfig];
}; // eslint-disable-next-line import/prefer-default-export


var getFieldConfig = function getFieldConfig(field) {
  return fieldConfigs().find(function (f) {
    return f.type === field.type;
  });
};

exports.getFieldConfig = getFieldConfig;